import React, { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../../services/api';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setIsLoading(true);

    try {
      const data = await authApi.forgotPassword(email.trim());
      if (data.error) throw new Error(data.error);
      setSuccess(true);
      if (data.resetLink) {
        console.log('🔗 [FORGOT-PASSWORD] Reset link:', data.resetLink);
      }
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Failed to send reset email. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #ff9a56 0%, #ff6b35 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '20px',
        width: '100%',
        maxWidth: '420px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '25px' }}>
          <span style={{ fontSize: '48px' }}>🥭</span>
          <h1 style={{ margin: '12px 0 5px 0', fontSize: '26px', color: '#333' }}>Forgot Password</h1>
          <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>Enter your email and we'll send you a reset link</p>
        </div>

        {error && (
          <div style={{
            padding: '12px',
            background: '#ffebee',
            color: '#c62828',
            borderRadius: '10px',
            marginBottom: '20px',
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}

        {success ? (
          <div>
            <div style={{
              padding: '16px',
              background: '#e8f5e9',
              color: '#2e7d32',
              borderRadius: '10px',
              marginBottom: '20px',
              fontSize: '14px'
            }}>
              ✅ If an account with that email exists, a password reset link has been sent. Please check your email.
            </div>
            <Link
              to="/login"
              style={{
                display: 'block',
                textAlign: 'center',
                color: '#ff6b35',
                fontWeight: '600',
                textDecoration: 'none',
                fontSize: '14px'
              }}
            >
              ← Back to Login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '14px', color: '#333' }}>
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="your@email.com"
                style={{
                  width: '100%',
                  padding: '14px',
                  border: '2px solid #e0e0e0',
                  borderRadius: '10px',
                  fontSize: '16px',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              style={{
                width: '100%',
                padding: '16px',
                background: isLoading ? '#ccc' : 'linear-gradient(135deg, #ff9a56 0%, #ff6b35 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '700',
                cursor: isLoading ? 'not-allowed' : 'pointer',
                marginBottom: '20px'
              }}
            >
              {isLoading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <Link
              to="/login"
              style={{
                display: 'block',
                textAlign: 'center',
                color: '#ff6b35',
                fontWeight: '600',
                textDecoration: 'none',
                fontSize: '14px'
              }}
            >
              ← Back to Login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
